/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Selector.module.scss'

function Option({ option, selected, enabled, onChange }) {
    return (
        <label
            htmlFor={option}
            className={classnames(styles.filterRow, { [styles.availableOption]: enabled })}
        >
            <input
                id={option}
                type="checkbox"
                checked={selected}
                name={option}
                onChange={onChange}
            />
            <span className={styles.filterRowLabel}>
                {option}
            </span>
        </label>
    )
}

Option.propTypes = {
    option: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
}

export { Option }
